import { PaperBox } from "../../../../components/Layout/PaperBox";
import { formatarValorMonetario } from "../../../../helpers/masks";
import { Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { TLimiteConfiguracoes } from "../../../../types/api/cadastros/detalhar-publico";
import moment from "moment";

export default function CardLimiteConfigs({
    configuracoes
}: CardLimiteConfigsProps) {
    return (
        <PaperBox title="Status do limite crédito">
            <TableContainer>
                <Table size="small">
                    <TableBody>
                        {configuracoes.map((config) => {
                            return (
                                headers.map((header, index) => {
                                    const possuiContrato = transformValue(resolveValue(config, 'possui_contrato', false));
                                    if (['contrato_valor', 'contrato_vencimento'].includes(header.config) && 
                                        possuiContrato === 'Não') {
                                        return null;
                                    }
                                    return (
                                        <TableRow
                                            key={`${config.tipo}-${header.config}-${index}`}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell sx={{ paddingX: 2 }} align="left">
                                                <Typography fontWeight="bold">{header.label}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 3 }} align="right">
                                                <Typography variant="subtitle2" color={['Sim', 'NÃO CADASTRADO'].includes(transformValue(resolveValue(config, header.config, header.data))) ? '#c73636' : ''}
                                                >
                                                    {header.numeric
                                                        ? formatarValorMonetario(resolveValue(config, header.config, header.data))
                                                        : transformValue(resolveValue(config, header.config, header.data))}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </PaperBox>
    );
}

interface CardLimiteConfigsProps {
    configuracoes: TLimiteConfiguracoes[];
}

const headers: THeaders[] = [
    { label: "Tipo", config: "tipo", numeric: false, data: false },
    { label: "Valor total", config: "valor", numeric: true, data: false },
    { label: "Possui contrato", config: "possui_contrato", numeric: false, data: false },
    { label: "Valor contrato", config: "contrato_valor", numeric: true, data: false },
    { label: "Vencimento contrato", config: "contrato_vencimento", numeric: false, data: true },
    { label: "Possui registro", config: "possui_registro", numeric: false, data: false },
    { label: "Nota promissória", config: "nota_promissoria", numeric: false, data: false },
    { label: "Alienação fiduciária", config: "alienacao_fiduciaria", numeric: false, data: false },
    { label: "Hipotecária", config: "hipotecaria", numeric: false, data: false },
    { label: "Pignoratícia", config: "pignoraticia", numeric: false, data: false },
    { label: "Outros", config: "outros", numeric: false, data: false },
];

type THeaders = {
    label: string,
    config: keyof TLimiteConfiguracoes,
    numeric: boolean
    data: boolean
}

const resolveValue = (config: TLimiteConfiguracoes, path: keyof TLimiteConfiguracoes, data: boolean): string => {
    if (data) {
        const rawValue = String(config[path]).trim();

        if (!rawValue || rawValue === '0000-00-00' || rawValue === 'null') return 'NÃO CADASTRADO';

        const date = moment(rawValue, 'YYYY-MM-DD', true);
        return date.isValid() ? date.format('DD/MM/YYYY') : 'NÃO CADASTRADO';
    }

    return String(config[path] ?? 'NÃO CADASTRADO');
};

const transformValue = (value: string) => {

    const valor = value.toUpperCase().trim()
    switch (valor) {
        case 'S': return 'Sim';
        case ' ': return 'Não';
        case '': return 'Não';
        case 'N': return 'Não';
        case 'NÃO CADASTRADO': return 'NÃO CADASTRADO';
        default: return valor;

    }
}